module.exports = __webpack_public_path__ + "img/meet_chrome.2eeda783.png";